<template>
    <div>
        <card-header title="New Content Provider" icon="fa-plus" />

        <card-body>
            <content-provider-form :provider="provider" />
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!provider.title"
                    ><i class="fas fa-plus mr-2"></i>New Content Provider
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";


    import {client as http} from "@/http_client";
    import ContentProviderForm from "./ProviderForm.vue";

    export default {
        components: {ContentProviderForm, CardHeader, CardToolbar, CardBody, CardFooter},
        props: ['card'],
        data() {
            return {
                provider: {}
            };
        },
        methods: {
            submit: function () {
                this.$emit('loading', true);
                http.post('content-providers', this.provider, {force: true}).then(response => {
                    this.$reloadCard('content-providers');
                    this.$closeCard(this.card);
                }).catch(err => {
                    if (err) {
                        window.alert('An error occurred while saving the provider.');
                    }
                    this.$emit('loading', false);
                });
            }
        }
    };
</script>
